const UserIcon = ({ className, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 25 25"
      className={className ? className : "w-[25px] h-[25px]"}
      {...rest}
    >
      <g
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.25"
        clipPath="url(#clip0_5286_44409)"
      >
        <path d="M12.203 15.5a6 6 0 1 0 0-12 6 6 0 0 0 0 12M3.203 20.75c1.816-3.138 5.114-5.25 9-5.25s7.184 2.112 9 5.25"></path>
      </g>
      <defs>
        <clipPath id="clip0_5286_44409">
          <path fill="#fff" d="M.203.5h24v24h-24z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default UserIcon;
